import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  Checkbox,
  Modal,
  Upload,
  InputNumber,
  Radio,
} from "antd";
// import {
//   ChangeQuestionConfirmDirty,
//   ChangeQuestionTableData,
//   ChangeQuestionModalState,
// } from "../../../actions/trainerAction";
import {
  changeQuestionModalState,
  changeQuestionFormConfirmDirty,
  changeQuestionTableLoadingStatus,
} from "../../../reducers/trainer";
import { SecurePost } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../../components/common/alert";
import { retriveToken } from "../../../services/AuthServices";
import {
  givenComponentMath,
  givenComponentsOthers,
  givenDifficulties,
  givenEnglishTopics,
  givenExams,
  givenLevels,
  givenMathsTopics,
  givenSchools,
  givenScienceTopics,
  givenTopics,
  givenYears,
  textModules,
} from "../../common/constants";
import ReactQuill from "react-quill";
import RichTextEditor from "../../RichTextEditor";
import { UploadOutlined } from "@ant-design/icons";

import { useForm } from "antd/es/form/Form";
import { fetchAllQuestions } from "../../../features/trainerAsync";

const NewQuestionForm = () => {
  const dispatch = useDispatch();
  const { selectedSubjects } = useSelector((state) => state.trainer);
  const { subjectTableData } = useSelector((state) => state.admin);
  const [form] = Form.useForm();
  const [subject, setSubject] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [body, setBody] = useState("");
  const [explanation, setExplanation] = useState("");
  const [questionDetails, setQuestionDetails] = useState({
    isMcq: true,
    isShort: false,
    isLong: false,
    isComposition: false,
    position: "left",
    unit: "",
    questionimage: null,
    questionimageUrl: "",
    options: [
      { image: null, body: null, isAnswer: false },
      { image: null, body: null, isAnswer: false },
      { image: null, body: null, isAnswer: false },
      { image: null, body: null, isAnswer: false },
    ],
  });
  const [adding, setAdding] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [level, setLevel] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [school, setSchool] = useState("");
  const [year, setYear] = useState("");
  const [component, setComponent] = useState("");
  const [exam, setExam] = useState("");
  const [topic, setTopic] = useState("");
  const [inputs, setInputs] = useState([""]);
  const [questionFileList, setQuestionFileList] = useState([]);
  const [optionFileLists, setOptionFileLists] = useState({});
  const [fifthOptionAddButtonVisible, setFifthOptionAddButtonVisible] =
    useState(true);

  useEffect(() => {
    form.setFieldsValue({ questionbody: body, explanation });
  }, [body, explanation]);

  const onValuesChange = (changedValues) => {
    if (changedValues.questionbody !== undefined)
      setBody(changedValues.questionbody);
    if (changedValues.explanation !== undefined)
      setExplanation(changedValues.explanation);
  };

  const handlePositionChange = useCallback((e) => {
    setQuestionDetails((prev) => ({ ...prev, position: e.target.value }));
  }, []);

  const handleInputChange = useCallback((index, event) => {
    const { value } = event.target;
    setInputs((prev) => {
      const updatedInputs = [...prev];
      updatedInputs[index] = value;
      return updatedInputs;
    });
  }, []);

  const handleAddInput = useCallback(() => {
    setInputs((prev) => [...prev, ""]);
  }, []);

  const handleRemoveInput = useCallback((index) => {
    setInputs((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const addFifthOption = useCallback(() => {
    setFifthOptionAddButtonVisible(false);
    setQuestionDetails((prev) => ({
      ...prev,
      options: [...prev.options, { image: null, body: null, isAnswer: false }],
    }));
  }, []);

  const showCustomAlert = useCallback(() => {
    Modal.confirm({
      title: "Confirm",
      content: "Empty option cannot be set as answer",
      okText: "I understand",
      cancelText: null,
    });
  }, []);

  const handleLevelDifficultyChange = useCallback((name, value) => {
    if (name === "level") setLevel(value);
    else if (name === "difficulty") setDifficulty(value);
  }, []);

  const handleSchoolChange = useCallback((value) => {
    setSchool(value);
  }, []);

  const handleYearChange = useCallback((value) => {
    setYear(value);
  }, []);

  const handleComponentChange = useCallback((value) => {
    setComponent(value);
  }, []);

  const handleExamChange = useCallback((value) => {
    setExam(value);
  }, []);

  const handleTopicChange = useCallback((value) => {
    setTopic(value);
  }, []);

  const handleSubjectChange = useCallback(
    (topicName) => {
      const selected = subjectTableData.find((d) => d.topic === topicName);
      if (selected) {
        setSubject(selected._id); // store id for backend
        setSubjectName(selected.topic); // store topic text for UI logic
      }
      setTopic(""); // reset topic
    },
    [subjectTableData]
  );

  const handleUnitChange = useCallback((value) => {
    setQuestionDetails((prev) => ({ ...prev, unit: value }));
  }, []);

  const optionTextChange = useCallback(
    (e, i) => {
      const newOptions = [...questionDetails.options];
      newOptions[i] = { ...newOptions[i], body: e.target.value };
      const isImageEmpty = !newOptions[i].image;
      const isBodyEmpty = !newOptions[i].body;
      if (isImageEmpty && isBodyEmpty) {
        newOptions[i].isAnswer = false;
      }
      setQuestionDetails((prev) => ({ ...prev, options: newOptions }));
    },
    [questionDetails.options]
  );

  const answerOptionSwitch = useCallback(
    (e, i) => {
      const option = questionDetails.options[i];
      const hasBody = option.body && option.body !== "";
      const hasImage = option.image;
      if (hasBody || hasImage) {
        const newOptions = [...questionDetails.options];
        newOptions[i] = { ...option, isAnswer: e.target.checked };
        setQuestionDetails((prev) => ({ ...prev, options: newOptions }));
      } else {
        showCustomAlert();
      }
    },
    [questionDetails.options, showCustomAlert]
  );

  const optionImageOnChange = useCallback(
    (f, i) => {
      const newOptions = [...questionDetails.options];
      newOptions[i] = {
        ...newOptions[i],
        image: f ? `${apis.BASE}/${f.link}` : null,
      };
      const isImageEmpty = !newOptions[i].image;
      const isBodyEmpty = !newOptions[i].body;
      if (isImageEmpty && isBodyEmpty) {
        newOptions[i].isAnswer = false;
      }
      setQuestionDetails((prev) => ({ ...prev, options: newOptions }));
      setSubmitDisabled(false);
    },
    [questionDetails.options]
  );

  const changeQuestionImage = useCallback((f) => {
    setQuestionDetails((prev) => ({
      ...prev,
      questionimage: f?.link ? `/${f.link}` : null,
    }));
    setSubmitDisabled(false);
  }, []);

  const beforeUpload = useCallback(() => {
    setSubmitDisabled(true);
  }, []);

  const handleSubmit = useCallback(async () => {
    try {
      const values = await form.validateFields();
      let isValid = true;
      let hasAnswer = 0;
      const options = questionDetails.options.map((element) => {
        const isImageEmpty = !element.image;
        const isBodyEmpty = !element.body || element.body === "";
        if (questionDetails.isMcq && isImageEmpty && isBodyEmpty) {
          isValid = false;
        }
        if (element.isAnswer) hasAnswer++;
        return {
          optbody: element.body,
          optimg: element.image,
          isAnswer: element.isAnswer,
        };
      });

      if (!isValid) {
        Alert("warning", "Warning!", "Please fill all the options");
        return;
      }

      if (
        (questionDetails.isMcq && hasAnswer === 0) ||
        (!questionDetails.isMcq && !inputs[0])
      ) {
        Alert("warning", "Warning!", "There must be at least one right answer");
        return;
      }

      setAdding(true);
      const response = await SecurePost({
        url: apis.CREATE_QUESTIONS,
        data: {
          body,
          options,
          isMcq: questionDetails.isMcq,
          isShort: questionDetails.isShort,
          isLong: questionDetails.isLong,
          position: questionDetails.position,
          unit: questionDetails.unit,
          answer: inputs.filter((input) => input !== ""),
          quesimg: questionDetails.questionimage,
          quesimgUrl: questionDetails.questionimageUrl,
          subject: subject,
          explanation,
          weightage: values.weightage,
          difficulty,
          level,
          exam,
          component,
          school,
          year,
          topic,
        },
      });

      setAdding(false);
      if (response.data.success) {
        dispatch(changeQuestionModalState(false));
        Alert("success", "Success", response.data.message);
        dispatch(fetchAllQuestions(selectedSubjects));
        form.resetFields();
        setQuestionDetails({
          isMcq: true,
          isShort: false,
          isLong: false,
          isComposition: false,
          position: "left",
          unit: "",
          questionimage: null,
          questionimageUrl: "",
          options: [
            { image: null, body: null, isAnswer: false },
            { image: null, body: null, isAnswer: false },
            { image: null, body: null, isAnswer: false },
            { image: null, body: null, isAnswer: false },
          ],
        });
        setSubject("");
        setBody("");
        setExplanation("");
        setLevel("");
        setDifficulty("");
        setSchool("");
        setYear("");
        setComponent("");
        setExam("");
        setTopic("");
        setInputs([""]);
        setFifthOptionAddButtonVisible(true);
      } else {
        dispatch(changeQuestionModalState(false));
        Alert("warning", "Warning!", response.data.message);
      }
    } catch (error) {
      setAdding(false);
      Alert("error", "Error!", error.response?.data?.message || error.message);
    }
  }, [
    form,
    body,
    explanation,
    questionDetails,
    inputs,
    subject,
    difficulty,
    level,
    exam,
    component,
    school,
    year,
    topic,
    selectedSubjects,
    dispatch,
  ]);

  const handleQuestionChange = (info) => {
    setQuestionFileList(info.fileList);

    if (info.file.status === "done") {
      changeQuestionImage(info.file.response);
    } else if (info.file.status === "error") {
      console.error("Question image upload failed");
    }
  };

  const handleOptionChange = (info, i) => {
    setOptionFileLists((prev) => ({
      ...prev,
      [i]: info.fileList,
    }));

    if (info.file.status === "done") {
      optionImageOnChange(info.file.response, i);
    } else if (info.file.status === "error") {
      console.error("Option image upload failed");
    }
  };

  const handleQuestionRemove = () => {
    setQuestionFileList([]);
    changeQuestionImage({});
  };

  const handleOptionRemove = (i) => {
    setOptionFileLists((prev) => {
      const updated = { ...prev };
      updated[i] = [];
      return updated;
    });
    optionImageOnChange(null, i);
  };

  // const questionImageProps = {
  //   name: "file",
  //   action: `${apis.BASE}${apis.FILE_UPLOAD}?Token=${retriveToken()}`,
  //   listType: "picture",
  //   fileList,
  //   onChange: (info) => {
  //     if (info.file.status === "done") {
  //       changeQuestionImage(info.file.response);
  //     } else if (info.file.status === "error") {
  //       console.error("Image upload failed");
  //     }
  //   },
  // };

  console.log("sub", subject, topic, subjectName);

  return (
    <div className="register-subject-form">
      <div className="register-trainer-form-body">
        <Form form={form} onFinish={handleSubmit} layout="vertical" onValuesChange={onValuesChange}>
          <div>
            <Row gutter={[16, 16]} align="middle">
              <Col span={8}>
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please select a subject!" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a subject"
                    optionFilterProp="children"
                    value={subjectName}
                    onChange={handleSubjectChange}
                  >
                    {subjectTableData.map((d) => (
                      <Select.Option key={d._id} value={d.topic}>
                        {d.topic}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={16} className="flex justify-end">
                <Radio.Group
                  options={[
                    { label: "MCQ Type", value: "MCQ" },
                    { label: "Open-ended Short Ans.", value: "SHORT" },
                    { label: "Open-ended Long Ans.", value: "LONG" },
                    { label: "Composition", value: "COMPOSITION" },
                  ]}
                  onChange={({ target: { value } }) => {
                    setQuestionDetails((prev) => ({
                      ...prev,
                      isMcq: value === "MCQ",
                      isShort: value === "SHORT",
                      isLong: value === "LONG",
                      isComposition: value === "COMPOSITION",
                    }));
                  }}
                  value={
                    questionDetails.isMcq
                      ? "MCQ"
                      : questionDetails.isShort
                      ? "SHORT"
                      : questionDetails.isLong
                      ? "LONG"
                      : questionDetails.isComposition
                      ? "COMPOSITION"
                      : ""
                  }
                  optionType="button"
                  buttonStyle="solid"
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={4}>
                <Form.Item
                  label="Level"
                  name="level"
                  rules={[
                    { required: true, message: "Please select a level!" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Level"
                    optionFilterProp="children"
                    onChange={(value) =>
                      handleLevelDifficultyChange("level", value)
                    }
                    value={level}
                  >
                    {givenLevels.map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Difficulty"
                  name="difficulty"
                  rules={[
                    { required: true, message: "Please select a difficulty!" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Difficulty"
                    optionFilterProp="children"
                    onChange={(value) =>
                      handleLevelDifficultyChange("difficulty", value)
                    }
                    value={difficulty}
                  >
                    {givenDifficulties.map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label="School" name="school">
                  <Select
                    showSearch
                    placeholder="Select School"
                    optionFilterProp="children"
                    value={school}
                    onChange={handleSchoolChange}
                  >
                    {givenSchools.map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label="Year" name="year">
                  <Select
                    showSearch
                    placeholder="Select Year"
                    optionFilterProp="children"
                    value={year}
                    onChange={handleYearChange}
                  >
                    {givenYears.map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="Component"
                  name="component"
                  rules={[
                    { required: true, message: "Please select a component!" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Component"
                    optionFilterProp="children"
                    value={component}
                    onChange={handleComponentChange}
                  >
                    {(subjectName === "Mathematics"
                      ? givenComponentMath
                      : givenComponentsOthers
                    ).map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label="Exam" name="exam">
                  <Select
                    showSearch
                    placeholder="Select Exam"
                    optionFilterProp="children"
                    value={exam}
                    onChange={handleExamChange}
                  >
                    {givenExams.map((d) => (
                      <Select.Option key={d.value} value={d.value}>
                        {d.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {subject && (
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Topic"
                    name="topic"
                    rules={[
                      { required: true, message: "Please select a topic!" },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select Topic"
                      optionFilterProp="children"
                      value={topic}
                      onChange={handleTopicChange}
                    >
                      {(subjectName === "Mathematics"
                        ? givenMathsTopics
                        : subjectName === "Science"
                        ? givenScienceTopics
                        : subjectName === "English"
                        ? givenEnglishTopics
                        : []
                      ).map((d) => (
                        <Select.Option key={d.value} value={d.value}>
                          {d.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row gutter={[16, 16]}>
              <Col span={20}>
                <Form.Item
                  label="Question"
                  name="questionbody"
                  rules={[
                    { required: true, message: "Please enter the question!" },
                  ]}
                >
                  <RichTextEditor />
                </Form.Item>
              </Col>
              <Col span={4} className="text-center">
                {questionDetails.isImage ? (
                  <Form.Item label="Question Image" name="questionimage">
                    <Upload
                      name="file"
                      action={`${apis.BASE}${
                        apis.FILE_UPLOAD
                      }?Token=${retriveToken()}`}
                      listType="picture"
                      fileList={questionFileList}
                      beforeUpload={beforeUpload}
                      onChange={handleQuestionChange}
                      onRemove={handleQuestionRemove}
                    >
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Form.Item>
                ) : (
                  <Form.Item
                    label="Question Image Link"
                    name="questionimageUrl"
                  >
                    <Input
                      value={questionDetails.questionimageUrl}
                      onChange={(e) =>
                        setQuestionDetails((prev) => ({
                          ...prev,
                          questionimageUrl: e.target.value,
                        }))
                      }
                    />
                  </Form.Item>
                )}
                <Radio.Group
                  options={[
                    { label: "Use as link", value: "LINK" },
                    { label: "Use as image", value: "IMAGE" },
                  ]}
                  onChange={({ target: { value } }) => {
                    setQuestionDetails((prev) => ({
                      ...prev,
                      isLink: value === "LINK",
                      isImage: value === "IMAGE",
                    }));
                  }}
                  value={questionDetails.isLink ? "LINK" : "IMAGE"}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={20}>
                <Form.Item
                  label="Explanation"
                  name="explanation"
                  rules={[
                    { required: true, message: "Please enter an explanation!" },
                  ]}
                >
                  <RichTextEditor />
                </Form.Item>
              </Col>
              <Col span={4} className="text-center">
                <Form.Item
                  label="Weightage"
                  name="weightage"
                  rules={[
                    { required: true, message: "Please enter weightage!" },
                  ]}
                >
                  <InputNumber min={1} max={10} />
                </Form.Item>
              </Col>
            </Row>
            {questionDetails.isShort && (
              <Row gutter={[16, 16]} align="middle">
                <Col span={12}>
                  <Form.Item label="Unit" name="unit">
                    <Input
                      value={questionDetails.unit}
                      onChange={(e) => handleUnitChange(e.target.value)}
                      placeholder="Enter unit"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Radio.Group
                    options={[
                      { label: "Left Unit", value: "left" },
                      { label: "Right Unit", value: "right" },
                    ]}
                    onChange={handlePositionChange}
                    value={questionDetails.position}
                    optionType="button"
                    buttonStyle="solid"
                  />
                </Col>
              </Row>
            )}
            {questionDetails.isMcq ? (
              <div className="grid grid-cols-2 gap-4 mt-4">
                {questionDetails.options.map((option, i) => (
                  <div key={i} className="border border-gray-200 p-4 rounded">
                    <Row gutter={[16, 16]}>
                      <Col lg={14} sm={24}>
                        <Form.Item
                          label={`Option ${i + 1}`}
                          name={`option${i + 1}`}
                        >
                          <Input.TextArea
                            value={option.body}
                            onChange={(e) => optionTextChange(e, i)}
                            rows={2}
                          />
                        </Form.Item>
                      </Col>
                      <Col lg={8} sm={12} className="text-center">
                        <Form.Item
                          label={`Option ${i + 1} Image`}
                          name={`option${i + 1}Image`}
                        >
                          <Upload
                            name="file"
                            action={`${apis.BASE}${
                              apis.FILE_UPLOAD
                            }?Token=${retriveToken()}`}
                            listType="picture"
                            fileList={optionFileLists[i] || []}
                            beforeUpload={beforeUpload}
                            onChange={(info) => handleOptionChange(info, i)}
                            onRemove={() => handleOptionRemove(i)}
                          >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col
                        lg={2}
                        sm={12}
                        className="flex items-center justify-center"
                      >
                        <Form.Item>
                          <Checkbox
                            checked={option.isAnswer}
                            onChange={(e) => answerOptionSwitch(e, i)}
                          >
                            Correct Answer
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {inputs.map((input, index) => (
                  <Row key={index} gutter={[16, 16]}>
                    <Col span={22}>
                      <Form.Item
                        label={`Answer ${index + 1}`}
                        name={`answer${index + 1}`}
                        rules={[
                          {
                            required: true,
                            message: "Please enter an answer!",
                          },
                        ]}
                      >
                        {questionDetails.isLong ||
                        questionDetails.isComposition ? (
                          <Input.TextArea
                            value={input}
                            onChange={(e) => handleInputChange(index, e)}
                            rows={5}
                          />
                        ) : (
                          <Input
                            value={input}
                            onChange={(e) => handleInputChange(index, e)}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={2} className="text-center">
                      <Button onClick={() => handleRemoveInput(index)}>
                        X
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Button type="dashed" onClick={handleAddInput} className="mt-2">
                  Add Answer
                </Button>
              </>
            )}
            <Row gutter={[16, 16]} className="mt-4">
              {questionDetails.isMcq && fifthOptionAddButtonVisible && (
                <Col span={12}>
                  <Button type="primary" onClick={addFifthOption}>
                    Add 5th Option
                  </Button>
                </Col>
              )}
              <Col span={12} className="flex justify-end">
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={submitDisabled}
                    loading={adding}
                    className="bg-blue-500 hover:bg-blue-600"
                  >
                    Create Question
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NewQuestionForm;
